import { render, staticRenderFns } from "./ProjectInfoHandOver.vue?vue&type=template&id=52f7ffb3&scoped=true"
import script from "./ProjectInfoHandOver.vue?vue&type=script&lang=js"
export * from "./ProjectInfoHandOver.vue?vue&type=script&lang=js"
import style0 from "./ProjectInfoHandOver.vue?vue&type=style&index=0&id=52f7ffb3&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52f7ffb3",
  null
  
)

export default component.exports